import { useEffect } from 'react';

/**
 * Checks if the current hostname is a volvopenta.com domain.
 * Matches: volvopenta.com, www.volvopenta.com, preprod.volvopenta.com, etc.
 */
function isVolvoPentaDomain(): boolean {
  const hostname = window.location.hostname;
  return hostname === 'volvopenta.com' || hostname.endsWith('.volvopenta.com');
}

/**
 * Adds a canonical link tag to the document head.
 * Only adds the tag on volvopenta.com domains (including preprod).
 * Cleans up on unmount to prevent stale tags in SPA navigation.
 *
 * @param path - The path portion of the canonical URL (e.g., '/connect/login')
 */
export function useCanonical(path: string): void {
  useEffect(() => {
    if (!isVolvoPentaDomain()) {
      return;
    }

    const canonicalUrl = `${window.location.origin}${path}`;

    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    return () => {
      link.remove();
    };
  }, [path]);
}
